module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular-Italic.f62af623.eot";